import React from 'react';
import {
  TenDaysMVPBanner,
  // TenDaysMVPChoose,
  TenDaysMVPQuestions,
  TenDaysMVPReady,
  TenDaysMVPSuccess,
  TenDaysMVPTerms,
  TenDaysMVPWhat,
  TenDaysMVPWorks
} from '../../sections';

const TenDaysMVPPage = () => {
  return (
    <>
      <TenDaysMVPBanner />
      {/* <TenDaysMVPChoose /> */}
      <TenDaysMVPWorks />
      <TenDaysMVPWhat />
      <TenDaysMVPSuccess />
      <TenDaysMVPQuestions />
      <TenDaysMVPReady />
      <TenDaysMVPTerms />
    </>
  );
};

export default TenDaysMVPPage;
